export function HistoricalDataSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/historical-data.svg'"></ng-include>`
    }
}